// main blank layout for all sub layouts

import Seo from '@Web/Src/Components/Seo';
import { router, usePage } from '@inertiajs/react';
import { useEffect } from 'react';

function Layout({ children }) {
    const metaTags = usePage().props.metaTags;

    useEffect(() => {
        // google tag manager
        router.on('navigate', (event) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page_path: event.detail.page.url,
                page_title: metaTags?.title,
            });
        });
    }, [metaTags]);

    return (
        <div>
            <Seo metaTags={metaTags} />

            {children}
        </div>
    );
}

export default Layout;
